import React, { useMemo } from "react";
import { Spinner } from "reactstrap";
import { VsiBubbleFavs } from "../styled/App.styled";
import ProgressBar from "../components/ProgressBar";
import { useVsiAppContext } from "../stores/VsiApp";
import { useDataWithRoute } from "../utils/hooks";

const enterpriseProgressConfig = [
  {
    type: "multi",
    key: "enterprise_alerts",
    fields: ["green", "yellow", "red"],
    colors: ["#4CF84C", "#F7FF00", "#F84C4C"],
    title: "Enterprise Alerts",
    denominator: 100
  }
];

export default function HealthReport() {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("STORAGE");

  const route = useMemo(() => `/api/v6/report/enterprise_summary_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);
  
  const dashboard = useMemo(() => {
    let totalUsable = 0;
    let totalUsed = 0;
    let totalAllocated = 0;
    let totalIops = 0;
    let totalIopsCapacity = 0;
    let ok = 0;
    let warnings = 0;
    let alerts = 0;
    let effective_total_free = 0;
    // let maxIops = 0;
    // let notMaxIops = 0;

    for (let i = 0; i < recordset.length; i++) {
      const datum = recordset[i];
      totalUsable = totalUsable + datum.usable_gb;
      totalUsed = totalUsed + datum.total_used;
      totalAllocated = totalAllocated + datum.total_allocated;
      totalIops = totalIops + datum.iops;
      if (parseInt(datum.iops) !== 0) {
        if (datum.iops_capacity === null) {
          totalIopsCapacity = totalIopsCapacity + datum.max_iops_capacity;
        } else {
          totalIopsCapacity = totalIopsCapacity + datum.iops_capacity;
        }
      }

      if (datum.array_status === "Array is active") {
        effective_total_free = effective_total_free + (Math.floor(datum.total_free / 4096) * 4096);
      }

      if (parseFloat(datum.max_alert_level) === 0.5) {
        warnings++;
      } else if (parseFloat(datum.max_alert_level) === 0) {
        alerts++;
      } else if (parseFloat(datum.max_alert_level) === 1) {
        ok++;
      }
    }

    let percentAllocated = totalAllocated / totalUsable;
    return {
      percent_used: totalUsed / totalUsable,
      percent_allocated: percentAllocated * 2,
      green: ok,
      yellow: warnings,
      red: alerts,
      percent_iops: totalIops / totalIopsCapacity
    }
  }, [recordset]);


  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubbleFavs>
      {enterpriseProgressConfig.map((blueprints, index) => {
        const data = blueprints.fields.map((field) => dashboard?.[field] || 0);
        return (
          <ProgressBar
            className={"mb-1"}
            data={data}
            denominator={blueprints.denominator}
            title={blueprints.title}
            colors={blueprints.colors}
            key={`progress-bar-${blueprints.title
              .toLowerCase()
              .split(" ")
              .join("-")}-${index}`}
            isMulti={blueprints.type === "multi"}
            thresholds={blueprints.thresholds}
            multiply={blueprints.multiply}
            size={"lg"}
          />
        );
      })}

    </VsiBubbleFavs>
  );
}
